import { render, staticRenderFns } from "./serviceMall.vue?vue&type=template&id=e57c575a&scoped=true"
import script from "./serviceMall.vue?vue&type=script&lang=js"
export * from "./serviceMall.vue?vue&type=script&lang=js"
import style0 from "./serviceMall.vue?vue&type=style&index=0&id=e57c575a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57c575a",
  null
  
)

export default component.exports